import React, { useState, useEffect } from 'react'
import NavLink from "../../../common/nav-link";

const navigation = [
  { name: 'Details', href: '#', current: true },
  { name: 'Address', href: '#address', current: false },
  { name: 'Integrations', href: '#integrations', current: false },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Nav() {
  const [tab, setTab] = useState('Details')

  return (
    <nav aria-label="Sidebar" className="sticky top-0 flex flex-1 flex-col">
      <ul role="list" className="-mx-2 space-y-1">
        { navigation.map((nav, index) => (
          <li key={`nav-${index}`}>
            <NavLink
              href={nav.href}
              tab={nav.name}
              setTab={setTab}
              activeTab={tab}
              baseClass='text-gray-700 hover:bg-gray-50 hover:text-indigo-600 group flex gap-x-3 rounded-md p-2 pl-3 text-sm/6 font-semibold'
              activeClass='group flex gap-x-3 rounded-md p-2 pl-3 text-sm/6 font-semibold bg-gray-50 text-indigo-600'
            >
              {nav.name}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
